import { render } from "./FloatingCart.vue?vue&type=template&id=1738ec58&scoped=true"
import script from "./FloatingCart.vue?vue&type=script&lang=js"
export * from "./FloatingCart.vue?vue&type=script&lang=js"

import "./FloatingCart.vue?vue&type=style&index=0&id=1738ec58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1738ec58"]])

export default __exports__